var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightCorner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 297,
    viewBox: "0 0 264 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1436_151093",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 264,
    height: 297
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 297,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1436_151093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266 0L266 298L13.0001 296L78 222.5L144.5 146.5L266 0Z",
    fill: "url(#paint0_linear_1436_151093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266 0L266 298L11.5 298L78 222.5L144.5 146.5L266 0Z",
    fill: "url(#paint1_linear_1436_151093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.443 153.903L264.443 145.683C61.2287 396.485 -214.177 696.847 -455.999 902.455L-455.999 909.27C-214.674 704.691 60.5389 405.044 264.443 153.903Z",
    fill: "#FF004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.443 87.5756L264.443 79.3804C61.5918 329.994 -213.911 630.733 -455.999 836.919L-455.999 843.734C-214.407 638.564 60.9019 338.541 264.443 87.5756Z",
    fill: "#FF004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.443 220.217L264.443 212.035C60.8656 463.037 -214.444 762.985 -455.999 968.117L-455.999 974.919C-214.94 770.817 60.1879 471.534 264.443 220.217Z",
    fill: "#FF004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.442 286.532L264.442 278.362C60.5016 529.515 -214.699 829.124 -456 1033.72L-456 1040.51C-215.207 836.93 59.8238 538.024 264.442 286.532Z",
    fill: "#FF004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.443 33.523L264.443 0.729492C63.032 250.628 -212.87 552.822 -455.999 761.067L-455.999 788.351C-214.903 584.16 60.2363 284.827 264.443 33.523Z",
    fill: "url(#paint2_linear_1436_151093)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1436_151093",
    x1: -454.441,
    y1: 1467.66,
    x2: 266,
    y2: 1467.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#550065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#631275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#6D1E80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#702283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1436_151093",
    x1: -454.441,
    y1: 1467.66,
    x2: 266,
    y2: 1467.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#550065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#631275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#6D1E80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#702283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1436_151093",
    x1: -214167,
    y1: -8044200,
    x2: -214167,
    y2: -8627050,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFCE6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DDCB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D5C365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#C9B45B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B79F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A0843A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#967832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#987A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B29948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#C6B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D4C164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DCCB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCorner);
export default __webpack_public_path__ + "static/media/rightCorner.a16942d576939c26a587c4dc6d859905.svg";
export { ForwardRef as ReactComponent };